module.exports = __webpack_public_path__ + "img/user.bbed8fb3.png";